var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stuff-list-container"},[(!_vm.list.length)?_c('div',{staticClass:"empty-tip"},[_vm._v(" 暂无物品～ ")]):_c('ul',{staticClass:"stuff-list"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }